import React, { useContext } from 'react';
import { SelectionContext, SelectedSalesItemContext } from './ControlBar';

const SalesDetailTab = () => {
  const { selectedSalesItem } = useContext(SelectedSalesItemContext);
  return (
    <div>
      <div className="control_blk_containers filter_blk mb_15">
        <h3 className="font_16 fw-semi text_black mb_15">Sale Detail</h3>
        {selectedSalesItem ? (
          <table className="w-100 table">
            <thead>
              <tr>
                <th>Field</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Region</td><td>{selectedSalesItem.region}</td></tr>
              <tr><td>Interchange Number</td><td>{selectedSalesItem.interchange_number}</td></tr>
              <tr><td>Mileage</td><td>{selectedSalesItem.mileage}</td></tr>
              <tr><td>all_parts_gross_sales</td><td>{selectedSalesItem.all_parts_gross_sales}</td></tr>
              <tr><td>part_source</td><td>{selectedSalesItem.part_source}</td></tr>
              <tr><td>Instock_screen_price</td><td>{selectedSalesItem.instock_screen_price}</td></tr>
              <tr><td>customer_category</td><td>{selectedSalesItem.customer_category}</td></tr>
              <tr><td>invoice_date</td><td>{selectedSalesItem.invoice_date ? selectedSalesItem.invoice_date.split('T')[0] : ''}</td></tr>
              <tr><td>invoice_number</td><td>{selectedSalesItem.invoice_number}</td></tr>
              <tr><td>detail_id</td><td>{selectedSalesItem.detail_id}</td></tr>
              <tr><td>days_instock</td><td>{selectedSalesItem.days_instock}</td></tr>
              {/* Add more rows as needed */}
            </tbody>
          </table>
        ) : (
          <div>No sale selected.</div>
        )}
      </div>
    </div>
  );
};
export default SalesDetailTab;
